module.exports = __webpack_public_path__ + "img/2026big16.23792420.png";